import { Trash2Icon } from 'lucide-react'

import { Button } from '@/components/ui'
import { AccountIdentity } from '@/modules/projects/components/Workbench/AccountIdentity'
import type { AccountDetails } from '@/modules/projects/components/Workbench/accounts'
import { Fact } from '@/modules/projects/components/Workbench/Fact'
import { Filed } from '@/modules/projects/components/Workbench/Filed'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import {
  FACTS_GRID,
  FILING_GAP,
} from '@/modules/projects/components/Workbench/mapLayout'
import { Missing } from './Missing'

interface LaneHeaderProps {
  lane: MapLane
  missing: number
  // A combined block says the filing once above its accounts when they all share it.
  filingShown: boolean
  onEdit: (details: AccountDetails) => void
  onRemove: () => void
}

export const LaneHeader = ({
  lane,
  missing,
  filingShown,
  onEdit,
  onRemove,
}: LaneHeaderProps) => {
  // The lane for pages printing no account is not an account, so it has nothing to correct.
  if (!lane.account) {
    return (
      <dl className={FACTS_GRID}>
        <Fact label="Number">
          <span className="text-ink-subtle">None printed on these pages</span>
        </Fact>
        <Filed filing={lane} />
        <Missing missing={missing} />
      </dl>
    )
  }

  return (
    <dl data-lane-label={lane.account.id} className={FACTS_GRID}>
      <AccountIdentity account={lane.account} onEdit={onEdit} />

      {lane.statementCount === 0 ? (
        <Fact label="Filed" className={FILING_GAP}>
          <span className="flex flex-col items-start gap-2 text-ink-subtle">
            Nothing yet
            <Button theme="destructive" size="xs" onClick={onRemove}>
              <Trash2Icon />
              Remove account
            </Button>
          </span>
        </Fact>
      ) : (
        <>
          {filingShown ? <Filed filing={lane} /> : null}
          <Missing missing={missing} />
        </>
      )}
    </dl>
  )
}
